import React, { Component } from 'react';
import { history } from "../../../../store";
import Datatable from '../../../common/datatable';

class FeatureTogglesTable extends Component {
  render() {
    const columns = [
      { prop: "name", title: "Name" },
      { prop: "description", title: "Description" },
      {
        prop: "enabled",
        title: "Enabled",
        format(data) {
          return data ? 'Y' : 'N';
        }
      }
    ];
    const actions = [
      {
        label: "Edit",
        callback: (row) => {
          history.push(`/admin/feature-toggles/${row.id}/edit`);
        }
      }
    ];

    const { featureToggles } = this.props;

    return (
      <Datatable
        data={featureToggles}
        columns={columns}
        actions={actions}
      />
    )
  }
}

export default FeatureTogglesTable;



// WEBPACK FOOTER //
// ./src/components/admin/feature-toggles/list/feature-toggles-table.jsx